import { css } from '@emotion/css';

import { Breakpoints, Spacing } from 'apps/shared/scripts/styles/constants';

export const buttonClassName = css({
  height: 42,
  marginLeft: Spacing.MD,
});

export const mobileClassName = css({
  [`@media (max-width: ${Breakpoints.SM}px)`]: {
    marginLeft: Spacing.XS,
  },
});

export const mobileIconClassName = css({
  [`@media (max-width: ${Breakpoints.SM}px)`]: {
    margin: 0,
  },
});

export const mobileTextClassName = css({
  [`@media (max-width: ${Breakpoints.SM}px)`]: {
    display: 'none',
  },
});
